module.exports = __webpack_public_path__ + "static/media/background1.5e0b5531.png";